var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid content-page-wrapper"},[_c('div',{staticClass:"row py-5"},[_c('div',{staticClass:"col-sm-12 col-md-6 m-auto"},[_c('h1',[_vm._v(_vm._s(_vm.$t('Reset password')))]),_vm._v(" "),_c('reset-password-form')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }